<template>
  <v-card
    @click="didSelect()"
    @mouseover="mouseDidOver"
  >
    <v-img
      :class="item.is_selected ? 'selected-top' : ''"
      :aspect-ratio="1"
      :src="getImage()"
    />
    <v-card-subtitle
      :class="item.is_selected ? 'selected-bot line-break px-2 py-1' : 'line-break px-2 py-1'"
    >
      {{ item.name }}
    </v-card-subtitle>
  </v-card>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'OptionsItemCell',

    props: {
      item: Object,
    },

    methods: {
      ...mapActions([
        'setGlancedOptionsItem',
      ]),

      getImage () {
        let image = require('@/assets/placeholder.png')
        if (this.item.image) image = this.item.image
        return image
      },

      didSelect () {
        this.setGlancedOptionsItem(null)
        this.$emit('itemDidSelected', this.item)
      },

      mouseDidOver () {
        this.setGlancedOptionsItem(this.item)
      },
    },
  }
</script>

<style scoped>
.line-break {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 0.75rem;
}

.selected-top {
  border-top: solid #1500AF 2px;
  border-left: solid #1500AF 2px;
  border-right: solid #1500AF 2px;
}

.selected-bot {
  border-bottom: solid #1500AF 2px;
  border-left: solid #1500AF 2px;
  border-right: solid #1500AF 2px;
}

</style>
